let newList =[
/*

  {
    "url": "",
    "month": "2026年8月",
    "day": "",
    "img": require("../assets/img/aboutUs/news/268-"),
    "title": "",
    "content": ""
  },
*/
  {
    "url": "https://mp.weixin.qq.com/s/rQpeq8kp7dbpTNAn5rgJBw",
    "month": "2026年8月",
    "day": "31",
    "img": require("../assets/img/aboutUs/news/268-5.jpg"),
    "title": "关注丨2026中国国际大数据产业博览会“人工智能数据工厂创新发展交流活动”成功举办",
    "content": "8月29日，人工智能数据工厂创新发展交流活动在贵阳举行。活动聚焦“建设数据工厂，释放数据价值”，围绕人工智能数据工厂建设、高质量数据集培育及数据标注产业提质升级等重点方向展开交流。"
  },
  {
    "url": "https://mp.weixin.qq.com/s/y2tj35yWEj-MSYgWRaUkIg",
    "month": "2026年8月",
    "day": "27",
    "img": require("../assets/img/aboutUs/news/268-4.png"),
    "title": "福祉展即将开幕 | 果不其然无障碍解决方案及相关产品亮相现场",
    "content": "北京福祉博览会即将启幕，中启联信科技集团战略投资企业果不其然无障碍科技有限公司将携整体无障碍解决方案及相关产品亮相现场，集中展示译语同传翻译等无障碍创新应用。"
  },
  {
    "url": "https://mp.weixin.qq.com/s/ZKVwYtLbDnljIcHbTfk_Ow",
    "month": "2026年8月",
    "day": "24",
    "img": require("../assets/img/aboutUs/news/268-3.png"),
    "title": "重磅发布｜中启联信数据工厂服务平台",
    "content": "中启联信正式发布数据工厂服务平台，以统一底座贯通数据采集、数据存储、数据标注和数据交付，集中管理项目、人员、进度、质量与成本，推动数据生产方式向标准化、可追溯、闭环化升级。"
  },
  {
    "url": "https://mp.weixin.qq.com/s/k6OfGCdZAkGGLI-Gv1gL_Q",
    "month": "2026年8月",
    "day": "10",
    "img": require("../assets/img/aboutUs/news/268-2.png"),
    "title": "中启联信深化区域数据服务协同布局 数据服务生态伙伴落地泉州",
    "content": "近日，中启联信与数元天擎正式签署AI数据产业生态合作协议，并授予其“中启联信·数据服务生态伙伴”牌匾，进一步深化区域数据服务协同布局，拓展数据服务生态合作。"
  },
  {
    "url": "https://mp.weixin.qq.com/s/mv0DkY1jaTMDm0xRz2Ie-g",
    "month": "2026年8月",
    "day": "4",
    "img": require("../assets/img/aboutUs/news/268-1.png"),
    "title": "推动数据标准研制 筑牢人工智能底座——中启联信科技集团深度参与“智能化数据工厂标准化研究”项目开题会",
    "content": "近日，“智能化数据工厂标准化研究”项目开题会在北京交通大学顺利召开。中启联信作为参编单位参会，围绕数据工厂标准体系展开研讨，并将结合平台与业务实践支撑标准研制工作。"
  },
  {
    "url": "https://mp.weixin.qq.com/s/viTuTh8qjewVmk6l5CJ1jQ",
    "month": "2026年7月",
    "day": "1",
    "img": require("../assets/img/aboutUs/news/267-1.jpg"),
    "title": "数智赋能 助推县域经济高质量发展——省、市、县、乡四级人大代表莅临闽江智能数据标注产业基地视察",
    "content": "为深入贯彻落实“奋勇争先突破年”部署要求，坚定不移做强做优数字经济，6月30日，闽清县人大常委会组织省、市、县、乡四级人大代表开展集中视察。视察组一行深入闽江智能数据标注产业基地，实地调研数字经济发展与产业提质升级工作。"
  },
  {
    "url": "https://mp.weixin.qq.com/s/71WMWhUQf97VpDVsxzFNyw",
    "month": "2026年7月",
    "day": "9",
    "img": require("../assets/img/aboutUs/news/267-2.jpg"),
    "title": "聚焦前沿 立足实践 | 中启联信与中国人民大学调研组共话数据要素发展与数字人才培养",
    "content": "7月8日，中国人民大学信息资源管理学院副院长任明教授率调研组到中启联信科技集团开展专题调研。此次调研以“数据要素市场化与价值化前沿”为主题，聚焦企业在公共数据开发利用、数据要素市场建设、数据安全与合规管理领域的创新实践，以及数据管理人才需求与专业培养方向。"
  },
  {
    "url": "https://mp.weixin.qq.com/s/xay3u6pEVdjHWVRSiBGmPA",
    "month": "2026年7月",
    "day": "13",
    "img": require("../assets/img/aboutUs/news/267-3.jpg"),
    "title": "科技赋能·振兴乡村 | 中启联信以数智技术赋能农业现代化",
    "content": "7月10日，由福州市科学技术局、福州市农业农村局联合主办的“科技赋能·振兴乡村”2026年福州市农业科技主题科普活动在东部办公区举办。中启联信科技集团受邀参加活动，全方位展示现代农业科技创新成果，以数字化、智能化技术赋能农业转型升级。"
  },
  {
    "url": "https://mp.weixin.qq.com/s/PelgV_5SSjto6iaML5gjYg",
    "month": "2026年7月",
    "day": "15",
    "img": require("../assets/img/aboutUs/news/267-4.jpg"),
    "title": "福建省数据管理局一行莅临闽江智能数据标注产业基地调研人工智能工作",
    "content": "7月14日，福建省数据管理局总工程师林涛一行莅临闽江智能数据标注产业基地（以下简称“闽江基地”）开展人工智能工作调研。集团董事长辜俊杰陪同调研。"
  },
  {
    "url": "https://mp.weixin.qq.com/s/3sFOw4hjnuZPWfV-CNoT_A",
    "month": "2026年7月",
    "day": "20",
    "img": require("../assets/img/aboutUs/news/267-5.png"),
    "title": "重磅落地！福建大数据交易平台与可信数据空间互通 打造数据交付全新标杆",
    "content": "近日，依托福建省数据要素流通综合服务平台体系，福建省数据流通控股有限公司建设运营的福建大数据交易平台实现与福建省三医联动医养数据流通基础设施（以下简称“可信数据空间”）双向互通，并联合中启联信科技集团成功落地多模态数据集安全可信交付案例。"
  },
  {
    "url": "https://mp.weixin.qq.com/s/D333MjL5whPY7ZESFt_wYQ",
    "month": "2026年6月",
    "day": "22",
    "img": require("../assets/img/aboutUs/news/266-3.png"),
    "title": "中启联信随中国信息协会专委会走进温州 政企共话数据产业未来",
    "content": "6月17日，中国信息协会数据集和数据标注专业委员会组织二十家行业企业赴浙江省温州市开展政企交流合作。中启联信科技集团作为随行企业代表团成员，深度参与此次交流活动，与温州市政府及相关部门共话数据产业发展新机遇，共谋政企协同合作新路径"
  },
  {
    "url": "https://mp.weixin.qq.com/s/AuyNCb2z4Fy_bKP15QUnMA",
    "month": "2026年6月",
    "day": "20",
    "img": require("../assets/img/aboutUs/news/266-2.jpg"),
    "title": "中启联信亮相2026鲲鹏昇腾轻量化场景方案发布会 联合华为发布AI数据标注一体机",
    "content": "6月17日，以“算力极致，AI极简”为主题的2026商业市场鲲鹏昇腾轻量化场景方案发布会在福州举办。本次大会汇聚政企客户、行业伙伴与技术专家，围绕轻量化算力落地应用、普惠AI创新实践及产业生态协同发展展开深度交流。"
  },
  {
    "url": "https://mp.weixin.qq.com/s/K1LeKZmwJv7gqHDKM5hvXA",
    "month": "2026年6月",
    "day": "19",
    "img": require("../assets/img/aboutUs/news/266-1.png"),
    "title": "粽叶飘香 端午安康",
    "content": "端午节临中夏，时清日复长，又是一年粽叶飘香的时节，在此，中启联信科技集团为大家送上最诚挚的节日祝愿，愿清香粽叶包裹四季顺遂，缕缕艾香驱散生活烦忧，乘风龙舟载来万事好运。愿您端午安康，万事顺遂！"
  },
  {
    "url": "https://mp.weixin.qq.com/s/SwEM0Cz6ZaoWgRt7XD5oTw",
    "month": "2026年5月",
    "day": "29",
    "img": require("../assets/img/aboutUs/news/265-5.jpg"),
    "title": "中启联信加入国家数据流通服务机构互认互通倡议推进组",
    "content": "近日，数据流通服务机构互认互通倡议推进组半年度工作会在江苏国际数据港会议中心顺利召开。来自全国主要数据交易所（中心）、行业头部数据流通服务平台企业及数据商共100余家单位代表参会。"
  },
  {
    "url": "https://mp.weixin.qq.com/s/Sds_hnKVAqUWs0fo4oh91A",
    "month": "2026年5月",
    "day": "19",
    "img": require("../assets/img/aboutUs/news/265-4.jpg"),
    "title": "科技赋能无障碍 中启联信携前沿科技走进多地助残活动",
    "content": "今年5月17日是第三十六次全国助残日，主题是“保障残疾人平等权益，促进残疾人融合发展”。为响应国家号召，推动残疾人事业高质量发展，中启联信携多款前沿科技辅助器具及技术服务，走进宁德、福州、泉州多地助残活动现场，以科技赋能无障碍生活，用暖心服务传递社会温情。"
  },
    {
    "url": "https://mp.weixin.qq.com/s/J0dylbqYJIAZjNpyhhQzRw",
    "month": "2026年5月",
    "day": "12",
    "img": require("../assets/img/aboutUs/news/265-3.jpg"),
    "title": "共筑数据流通底座 激发数字经济活力——福建省数据流通控股有限公司赴中启联信开展专题调研座谈",
    "content": "为深入贯彻国家数据局关于数据基础设施建设运营的战略部署，加快推进数据基础设施（福建）区域功能节点建设，近日，福建省数据流通控股有限公司董事长陈雯珊携“数通八闽”运营团队莅临中启联信科技集团，开展调研与座谈交流。集团董事长辜俊杰陪同调研。"
  },
  {
    "url": "https://mp.weixin.qq.com/s/xB5ezLuDdMwpG_ZtsXR1fQ",
    "month": "2026年5月",
    "day": "7",
    "img": require("../assets/img/aboutUs/news/265-2.png"),
    "title": "共筑产业新生态！中启联信加入福山具身智能产业联盟",
    "content": "4月30日，作为第九届数字中国建设峰会的重要组成部分，鼓楼区“AI驱动全域智治 数字赋能首善鼓楼”智能社会治理主题活动在福州朱紫坊30号院成功举办。"
  },
  {
    "url": "https://mp.weixin.qq.com/s/pzw3rKdNQ8SJp3EO-FDy7g",
    "month": "2026年5月",
    "day": "7",
    "img": require("../assets/img/aboutUs/news/265-1.jpg"),
    "title": "常德市武陵区党政代表团赴中启联信与闽江数据基地考察",
    "content": "4月29日至30日，常德市武陵区人民政府副区长吴金率党政代表团赴福州考察。代表团一行先后走进第九届数字中国建设峰会中启联信科技集团展区及闽江智能数据标注产业基地（以下简称“闽江数据基地”），调研企业技术创新成果与产业落地实践。"
  },
  {
    "url": "https://mp.weixin.qq.com/s/EL3H5R4gVLigrT2vXyC7Ug",
    "month": "2026年4月",
    "day": "29",
    "img": require("../assets/img/aboutUs/news/264-6.jpg"),
    "title": "媒体关注 | 闽江智能数据标注产业基地：数据筑基激活AI“新食粮”",
    "content": "走进位于闽清县梅溪镇的闽清人工智能与大数据产业基地，标注员专注于电脑屏幕上的激光雷达点云、图像和视频，通过“画框、分割、关键点标注”等方式，对原始数据进行结构化标记，为智能驾驶、具身智能、大模型等AI应用提供高质量训练数据，为人工智能“启蒙认知”。"
  },
  {
    "url": "https://mp.weixin.qq.com/s/JNsezLnjmjpPI4bVo6A-JQ",
    "month": "2026年4月",
    "day": "28",
    "img": require("../assets/img/aboutUs/news/264-5.jpg"),
    "title": "诚邀莅临 | 中启联信亮相第九届数字中国建设峰会",
    "content": "中启联信科技集团携旗下核心产品及解决方案，重磅亮相2026第九届数字中国建设峰会，全面展示数智融合创新成果。"
  },
  {
    "url": "https://mp.weixin.qq.com/s/iqTjzxR8PP0BL2GOHDGTMg",
    "month": "2026年4月",
    "day": "24",
    "img": require("../assets/img/aboutUs/news/264-4.png"),
    "title": "相约福州 ！中启联信邀您共聚第九届数字中国建设峰会",
    "content": "第九届数字中国建设峰会由国家发展改革委、国家数据局、国家网信办、工业和信息化部、福建省人民政府共同主办，将于4月29日至4月30日在福建省福州市举办。"
  },
  {
    "url": "https://mp.weixin.qq.com/s/QxXpIrv_B_XsVa-UtXgXJw",
    "month": "2026年4月",
    "day": "15",
    "img": require("../assets/img/aboutUs/news/264-3.png"),
    "title": "中启联信协办“2026数字中国创新大赛·数据标注赛道”",
    "content": "4月15日由数字中国建设峰会组委会指导福建省数据管理局福州市人民政府主办的“2026数字中国创新大赛·数据标注赛道”在福州市闽清县拉开帷幕。"
  },
  {
    "url": "https://mp.weixin.qq.com/s/_R8h6q5UwnE9Bw5HBIO7dw",
    "month": "2026年4月",
    "day": "13",
    "img": require("../assets/img/aboutUs/news/264-2.png"),
    "title": "【深化闽宁数字经济协作 共谋高质量发展新景】固原市政府、市数据局领导一行莅临中启联信考察交流",
    "content": "4月11日下午，固原市委常委、市人民政府副市长张学斌率固原市数据局、投资促进服务中心一行莅临中启联信科技集团（以下简称“中启联信”）考察交流。集团董事长辜俊杰等陪同接待。"
  },
  {
    "url": "https://mp.weixin.qq.com/s/Z8nzBovtSbcXnWH65MidNw",
    "month": "2026年3月",
    "day": "31",
    "img": require("../assets/img/aboutUs/news/263-7.jpg"),
    "title": "以语料促应用、以开放聚生态 | 中启联信受邀出席GDPS 2026“语料筑基、智生时代”语料主题论坛",
    "content": "3月28日，2026全球开发者先锋大会（GDPS）“语料筑基、智生时代”主题论坛在上海举行。"
  },
  {
    "url": "https://mp.weixin.qq.com/s/jd8ZqNB2T00Cy_xfOfKtaQ",
    "month": "2026年3月",
    "day": "27",
    "img": require("../assets/img/aboutUs/news/263-6.png"),
    "title": "鼓楼区委组织部领导莅临中启联信调研指导",
    "content": "3月24日，福州市鼓楼区委组织部组织部副部长詹城率“人工智能”人才集聚区调研工作专班莅临中启联信科技集团（以下简称“中启联信”）开展专题调研与座谈交流。集团副总经理蔡怀阳陪同调研。"
  },
  {
    "url": "https://mp.weixin.qq.com/s/Tl8XqxAfzaVSD3aCuf9IYw",
    "month": "2026年3月",
    "day": "20",
    "img": require("../assets/img/aboutUs/news/263-5.jpg"),
    "title": "中启联信受邀参加华为中国合作伙伴大会2026，多模态AI标注一体机重磅亮相商业市场展区",
    "content": "3月19至20日，以“因聚而升 融智有为”为主题的华为中国合作伙伴大会2026在深圳举办。本届大会旨在通过“伙伴+华为”在战略、能力、价值的全面融合、协同共进，实现高质量服务客户数智化升级，共创千行万业数智化的价值跃升。"
  },
  {
    "url": "https://mp.weixin.qq.com/s/AhjqkcLrqtdCtIq-Hviybw",
    "month": "2026年3月",
    "day": "18",
    "img": require("../assets/img/aboutUs/news/263-4.jpg"),
    "title": "甘肃庆阳市住建局领导莅临中启联信参观调研 共探数字赋能住建新路径",
    "content": "为深入贯彻庆阳市委市政府关于数字经济招商部署要求，考察引进数字经济领域优质企业和重点项目，以科技动能助推全市住建事业与经济社会高质量发展，3月17日下午，庆阳市住房和城乡建设局党组书记、局长牛维宇率队莅临中启联信科技集团（以下简称“中启联信”）参观调研。"
  },
  {
    "url": "https://mp.weixin.qq.com/s/MCBWM7y9dHnkFHoXX3xgzg",
    "month": "2026年3月",
    "day": "16",
    "img": require("../assets/img/aboutUs/news/263-3.png"),
    "title": "邀请函 | 中启联信邀您共赴华为中国合作伙伴大会2026",
    "content": "在人工智能蓬勃发展的时代浪潮中，高质量数据标注已成为驱动AI产业跃迁的核心引擎。"
  },
  {
    "url": "https://mp.weixin.qq.com/s/mgsAKiyMaBt2Ap7bUrFBrg",
    "month": "2026年3月",
    "day": "12",
    "img": require("../assets/img/aboutUs/news/263-2.jpg"),
    "title": "2026数字中国创新大赛·数据标注赛道报名开启",
    "content": "当前，数字中国建设迈入系统推进、整体跃升的关键阶段，数据作为核心生产要素，其价值释放与高效利用成为数字经济发展的核心抓手。"
  },
  {
    "url": "https://mp.weixin.qq.com/s/SJPEpgUujt3Hqfww1Jaq3g",
    "month": "2026年3月",
    "day": "3",
    "img": require("../assets/img/aboutUs/news/263-1.png"),
    "title": "【元宵节】灯火映万家 团圆共此时",
    "content": "新年的第一轮圆月，映照一年圆满的开端。中启联信祝大家人圆，事圆，团团圆圆，元宵节快乐！"
  },
  {
    "url": "https://mp.weixin.qq.com/s/MEejNUFT7nSm5fRlSDssCA",
    "month": "2026年2月",
    "day": "24",
    "img": require("../assets/img/aboutUs/news/262-3.png"),
    "title": "开工大吉 | 乘势而上 共赴新程！",
    "content": "岁序更新，万象启新。农历正月初八，中启联信科技集团正式开工！新的一年，让我们以坚定的步伐，以数据驱动创新，以智慧赋能未来，携手开启新征程，共铸科技新篇章！"
  },
  {
    "url": "https://mp.weixin.qq.com/s/x2hJCQ741EbAoZo0eMphTw",
    "month": "2026年2月",
    "day": "25",
    "img": require("../assets/img/aboutUs/news/262-2.jpg"),
    "title": "策马争春！中启联信人工智能与大数据产业基地正式揭牌，共筑数据产业新高地",
    "content": "2月24日，由中启联信科技集团（以下简称“中启联信”）联合闽清县产业投资有限公司共同建立的人工智能与大数据产业基地在闽清县梅溪新城隆重举行揭牌仪式。闽清县委书记赵春荣等县四套班子领导、集团董事长辜俊杰、各企业负责人及行业代表出席仪式。"
  },
  {
    "url": "https://mp.weixin.qq.com/s/V-7XEPBa9x6HflWeJQZqtA",
    "month": "2026年2月",
    "day": "13",
    "img": require("../assets/img/aboutUs/news/262-1.png"),
    "title": "【迎新春 送祝福】中启联信给您拜年啦",
    "content": "烟火辞旧岁，祥瑞迎新春。值此新春佳节，中启联信向一直以来信任与支持我们的客户、伙伴及全体员工致以最诚挚的问候与美好祝愿！愿您如骏马奔腾、一往无前；生活如马踏春景、步步生辉。祝您与家人新春快乐，马年大吉"
  },
  {
    "url": "https://mp.weixin.qq.com/s/eLdH7JdPQG9t6hXmbCeXlg",
    "month": "2026年1月",
    "day": "30",
    "img": require("../assets/img/aboutUs/news/261-4.png"),
    "title": "喜报！中启联信项目经理陈津彦荣获福州市“数字工匠”称号",
    "content": "近日，福州市数据管理局发布《关于福州市级“数字工匠”拟认定名单的公示》，经过严格评审，中启联信科技集团（以下简称“中启联信”）项目经理陈津彦成功入选，荣获2025年度福州市“数字工匠”荣誉称号。"
  },
  {
    "url": "https://mp.weixin.qq.com/s/eJbqnCmoa7aVKnldYmq5Rg",
    "month": "2026年1月",
    "day": "16",
    "img": require("../assets/img/aboutUs/news/261-3.png"),
    "title": "深化产学研融合·共筑工业数据新生态 | 福州大学5G+工业互联网研究院院长黄捷教授一行莅临中启联信考察交流",
    "content": "1月14日，福州大学5G+工业互联网研究院院长黄捷教授率领专家团队莅临中启联信科技集团（以下简称“中启联信”）考察交流。双方围绕工业数据标注的全流程实践、工具选型以及产学研合作模式等议题展开深入探讨。中启联信董事长辜俊杰及核心团队出席交流。"
  },
  {
    "url": "https://mp.weixin.qq.com/s/8nql0heQAXsQIw0a5nQp4A",
    "month": "2026年1月",
    "day": "7",
    "img": require("../assets/img/aboutUs/news/261-2.jpg"),
    "title": "【AI赋能农业 校企携手创新】 福建农林大学钟凤林副院长带队莅临中启联信考察交流",
    "content": "1月6日，福建农林大学园艺学院钟凤林副院长率专家团队莅临中启联信科技集团开展考察交流。集团副总经理蔡怀阳等相关负责人热情接待并全程陪同参观介绍。"
  },

  {
    "url": "https://mp.weixin.qq.com/s/3BaQ_v4L_12EhLbKP0lOOA",
    "month": "2026年1月",
    "day": "1",
    "img": require("../assets/img/aboutUs/news/261-1.png"),
    "title": "Hello2026！披星来时路载梦向未来",
    "content": "辞旧迎新，岁月更迭。中启联信科技集团祝大家新年快乐，万事如意，马到成功！"
  },

  {
    "url": "https://mp.weixin.qq.com/s/SggBNyKOk63aOTt7wZLN_g",
    "month": "2025年12月",
    "day": "30",
    "img": require("../assets/img/aboutUs/news/12-5.png"),
    "title": "中启联信参与起草的《数据资产—数据资产价值评估与定价指南》发布",
    "content": "2025年12月19日，由福建省标准化协会发布的《数据资产—数据资产价值评估与定价指南》（T/FJAS 029-2025）团体标准发布，将于12月31日起正式实施。中启联信科技集团作为起草单位之一，为标准提供了重要支撑。"
  },


  {
    "url": "https://mp.weixin.qq.com/s/iCKPhjlKpbaHr5rxwEnvrQ",
    "month": "2025年12月",
    "day": "23",
    "img": require("../assets/img/aboutUs/news/12-4.jpg"),
    "title": "福建省举行这场项目对接会！中启联信现场签约 优质项目落地生根",
    "content": "12月12日,福建省第十五届民营企业产业项目对接会暨闽台生物医药产业合作对接活动在福州新区举行,本届大会现场集中签约重大产业项目70个，总投资额达1123.9亿元，项目签约呈现出“产业新、项目实、领域广、支撑强”四大特点。签约项目不仅包括传统优势产业，还涵盖了新型显示、人工智能和机器人、低空经济等前沿重点领域和应用场景。"
  },

  {
    "url": "https://mp.weixin.qq.com/s/pN7wAd2P5X1nFMLRZ5OMgA",
    "month": "2025年12月",
    "day": "18",
    "img": require("../assets/img/aboutUs/news/12-3.jpg"),
    "title": "中启联信入选2025数智应用领先成果库，数智化能力获权威认证",
    "content": "12月5日，2025全球数字经济联盟（D50）峰会暨数智应用领先成果发布会在澳门展馆举办。大会以“数智融合·全球协同”为主题，聚焦数智应用成果发布与项目对接，搭建全球智能制造新技术、新成果交流合作枢纽，为各国企业提供国际展示舞台，推动全球数字经济高质量协同发展。"
  },

  {
    "url": "https://mp.weixin.qq.com/s/ViVsMTNojd-M-D2BktTjHQ",
    "month": "2025年12月",
    "day": "2",
    "img": require("../assets/img/aboutUs/news/12-2.jpg"),
    "title": "AI传递关怀 中启联信科技集团多款产品亮相第三届中国侨智发展大会",
    "content": "12月1日，第三届中国侨智发展大会在福州海峡国际会展中心开幕，本届大会以“五洲聚‘福’汇侨智·同心共圆中国梦”为永久主题，以“侨汇天下才·智创新时代”为年度主题，邀请安徽省作为主宾省，哈尔滨市作为主宾市，哈尔滨工业大学与同济大学作为主宾高校。"
  },
  {
    "url": "https://mp.weixin.qq.com/s/JwlhxINryosTxtTPk7Icmw",
    "month": "2025年12月",
    "day": "1",
    "img": require("../assets/img/aboutUs/news/12-1.png"),
    "title": "福建省数据管理局一行莅临中启联信调研",
    "content": "11月27日，福建省数据管理局数字经济处一行赴福州市鼓楼区开展数据产业集聚区及数据要素产业园现场调研，重点考察鼓楼区数据产业发展基础、典型数据企业、数据基础设施与公共平台建设、重点项目推进及谋划等情况。"
  },
  {
    "url": "https://mp.weixin.qq.com/s/rg_RuTEXC6N1B4QwYlfbxA",
    "month": "2025年11月",
    "day": "19",
    "img": require("../assets/img/aboutUs/news/11-6.png"),
    "title": "中启联信受邀出席数据标注龙头企业培育工作研讨会",
    "content": "为贯彻落实《关于促进数据标注产业高质量发展的实施意见》提出“培育一批深耕行业的数据标注瞪羚企业、独角兽企业”的部署要求，由中国信息协会数据标注专业委员会（以下简称“专委会”）组织的“数据标注龙头企业培育工作研讨会”今日在北京举办。"
  },
  {
    "url": "https://mp.weixin.qq.com/s/evaYZpycbsMzFSNuLo6qNA",
    "month": "2025年11月",
    "day": "17",
    "img": require("../assets/img/aboutUs/news/11-5.png"),
    "title": "校企协同促发展 实践育人谱新篇 | 福州职业技术学院到我司开展研学活动",
    "content": "11月13日，一场旨在搭建校企合作桥梁、助力学生实践成长的研学活动在中启联信科技集团（以下简称“中启联信”）顺利开展。福州职业技术学院组织数十名师生走进企业，通过实地参观和面对面交流，近距离感受科技企业的创新活力与现代技术的应用场景，为校企合作搭建了新的桥梁。"
  },
  {
    "url": "https://mp.weixin.qq.com/s/Qu_05gii050Km-EODgn-Zw",
    "month": "2025年11月",
    "day": "13",
    "img": require("../assets/img/aboutUs/news/11-4.jpg"),
    "title": "中启联信携福州引才政策走进武汉高校，搭建精准就业桥梁",
    "content": "为深入实施人才强市战略，持续打响“好年华 聚福州”人才工作品牌，由中共福州市委组织部、共青团福州市委员会、福州市人才发展集团等单位联合主办的2025年“引才聚榕”行动（华中片区）正在开展。"
  },
  {
    "url": "https://mp.weixin.qq.com/s/Tlc0iKcm5m7Le_LEE_WNwQ",
    "month": "2025年11月",
    "day": "7",
    "img": require("../assets/img/aboutUs/news/11-3.jpg"),
    "title": "中启联信入选国家级人工智能典型应用案例",
    "content": "10月31日，在山东济南举办的“东盟+中日韩（10+3）人工智能产业发展论坛”上，中启联信科技集团（以下简称“中启联信”）研发的“AI声学监测系统助力极度濒危野生动物保护”成果入选国家工业信息安全发展研究中心发布的《人工智能发展与合作典型应用案例集》，标志着公司在人工智能垂直领域的技术创新与应用能力获得国家级权威认可。"
  },
  {
    "url": "https://mp.weixin.qq.com/s/JxisYoA-52L3tzUAfvX4Ew",
    "month": "2025年11月",
    "day": "6",
    "img": require("../assets/img/aboutUs/news/11-2.png"),
    "title": "共商数据标准体系建设 共促数据要素高效流通 | 中启联信出席全国数据标准化技术委员会2025年第二次“标准周”会议",
    "content": "11月3日，全国数据标准化技术委员会（以下简称“全国数标委”）2025年第二次“标准周”活动在江苏省南京市举行。作为全国数标委成员单位，中启联信科技集团(以下简称“中启联信”）受邀参会，深度参与WG3数据流通利用标准工作组建设，积极推动全国数据标准的制定与落地实施，共同探讨数据要素发展路径。"
  },

  {
    "url": "https://mp.weixin.qq.com/s/JGqPs2-1cuwHDIVJE2C6Pg",
    "month": "2025年11月",
    "day": "4",
    "img": require("../assets/img/aboutUs/news/11-1.png"),
    "title": "中启联信助力福建省闽清县公共交通有限公司数据资源入表工作启动宣贯会圆满举办",
    "content": "为充分释放数据要素价值，防范数据资产价值应用风险，提升企业数据管理能力，推动数字经济高质量发展，10月29日，福建省闽清县公共交通有限公司（以下简称“闽清县公交公司”）数据资源入表工作启动宣贯会成功召开，中启联信科技集团（以下简称“中启联信”）提供专业技术支持，标志着闽清县公交公司正式开启数据资产化战略转型。"
  },

  {
    "url": "https://mp.weixin.qq.com/s/xTdnRoyskIqRm4LT6LTemg",
    "month": "2025年10月",
    "day": "29",
    "img": require("../assets/img/aboutUs/news/10-6.png"),
    "title": "闽桂携手共绘AI新图景！广西壮族自治区残联理事长黄丽娟一行莅临中启联信调研考察",
    "content": "10月24日，广西壮族自治区残联党组书记、理事长黄丽娟率调研组赴中启联信科技集团进行考察交流。福建省残疾人联合会党组成员、副理事长郑海生，集团董事长辜俊杰等陪同调研。此次交流聚焦人工智能与数据要素技术的产业融合与创新应用，双方围绕“数据驱动创新、AI赋能未来”展开深度探讨，旨在推动数字技术与区域经济高质量发展协同共进，为闽桂两地在科技创新领域的合作开辟新路径。"
  },

  {
    "url": "https://mp.weixin.qq.com/s/pZJWgRW9aVMvgI1VHwd3Cg",
    "month": "2025年10月",
    "day": "23",
    "img": require("../assets/img/aboutUs/news/10-5.png"),
    "title": "校企携手育新才 产教融合谱新篇——中启联信与四川大学锦江学院签约共建实践基地",
    "content": "为深入学习贯彻党的二十届三中全会精神和全国教育大会精神，搭建东西部人才供需对接平台，推动四川高校与闽浙两地企业跨区域“产学研就”深度融合，10月22日，在四川高校赴福建联合访企拓岗暨校企对接系列活动福州推介会上，中启联信科技集团（以下简称“中启联信”）与四川大学锦江学院现场签署了校企合作协议。"
  },

  {
    "url": "https://mp.weixin.qq.com/s/p0r6CVMBVR_GHScppzI7bw",
    "month": "2025年10月",
    "day": "15",
    "img": require("../assets/img/aboutUs/news/10-4.jpg"),
    "title": "中启联信大数据与人工智能产业园项目正式开工",
    "content": "10月13日，福州市2025年第四季度重大项目开工视频连线活动（闽清分会场）在闽清县中启联信大数据与人工智能产业园项目现场举行。闽清县赵春荣、陈禺、刘久兴、郑晓春等领导出席活动，中启联信科技集团董事长辜俊杰参加。"
  },

  {
    "url": "https://mp.weixin.qq.com/s/7h9xPHfe7_GtVdmcgCOWXQ",
    "month": "2025年10月",
    "day": "11",
    "img": require("../assets/img/aboutUs/news/10-3.png"),
    "title": "福建闽江智能数据标注产业基地落户闽清 全力打造国家级数据标注标杆",
    "content": "为加快培育数据要素市场、发展新质生产力，在全球人工智能产业进入 “数据驱动” 深水区的背景下，高质量训练数据作为 AI 模型的核心生产要素，需求正以年均超 30% 的速度爆发式增长。福州市闽清县锚定省级战略布局，联合中启联信科技集团共建福建闽江智能数据标注产业基地。"
  },

  {
    "url": "https://mp.weixin.qq.com/s/LZwY-6qIDy_8Y-Zq0KVC2Q",
    "month": "2025年10月",
    "day": "3",
    "img": require("../assets/img/aboutUs/news/10-2.png"),
    "title": "中启联信首批入选北京市数字经济标准化技术委员会具身智能工作组",
    "content": "为汇聚“政产学研用”各领域专业力量，共同推进数字经济标准化工作，根据《北京市专业标准化技术委员会管理办法》及《北京市数字经济标准化技术委员会章程》等有关要求，经广泛征集与遴选，北京市数字经济标准化技术委员会具身智能工作组吸纳了34家成员单位。"
  },

  {
    "url": "https://mp.weixin.qq.com/s/rScOgPw9JQ9ea34b_Te3xw",
    "month": "2025年10月",
    "day": "1",
    "img": require("../assets/img/aboutUs/news/10-1.jpg"),
    "title": "月满华诞 家国同庆",
    "content": "中启联信祝福祖国生日快乐！"
  },

  {
    "url": "https://mp.weixin.qq.com/s/lNOCgOqJ_X0yUX3-kpMPww",
    "month": "2025年9月",
    "day": "30",
    "img": require("../assets/img/aboutUs/news/9-10.jpg"),
    "title": "中启联信斩获佳绩！2025年“数据要素×”大赛福建分赛圆满落幕！",
    "content": "福建省数据管理局局长郭文忠、分赛专家委主任（福建省数据管理局原局长）吴宏武、福州大学党委副书记王向阳、福建省大数据集团副总经理吴英杰以及省直有关部门领导出席本次颁奖仪式并为获奖团队颁奖。"
  },

  {
    "url": "https://mp.weixin.qq.com/s/uF79C4i3H92GaqEI3z2wWg",
    "month": "2025年9月",
    "day": "23",
    "img": require("../assets/img/aboutUs/news/9-8.png"),
    "title": "中启联信助力第十二届丝绸之路国际电影节残健融合影院建设",
    "content": "9月23日上午，第十二届丝绸之路国际电影节·春天计划“残健融合共享影院”活动在福州光荣剧场开幕。作为本次活动的重要技术支持单位，中启联信科技有限公司以创新科技打破沟通壁垒，让无声世界同样精彩。"
  },

  {
    "url": "https://mp.weixin.qq.com/s/xr3oDDtDYU0ISegY_en6Wg",
    "month": "2025年9月",
    "day": "19",
    "img": require("../assets/img/aboutUs/news/9-7.png"),
    "title": "中启联信斩获2025年“数据要素×”大赛福建决赛一等奖",
    "content": "9月9日至12日，福建分赛组委会组织开展了2025年“数据要素×”大赛福建分赛决赛评审工作，经专家评审评议，中启联信科技集团（以下简称“中启联信”）凭借领先的技术创新方案和突出的数据要素价值，在众多优秀项目中脱颖而出，斩获科技创新赛道一等奖。"
  },

  {
    "url": "https://mp.weixin.qq.com/s/m_fL0Y5AsG-ANvPccWHzPQ",
    "month": "2025年9月",
    "day": "17",
    "img": require("../assets/img/aboutUs/news/9-6.png"),
    "title": "在榕省人大代表莅临中启联信开展专题调研活动",
    "content": "9月11日，市人大常委会组织部分我市的省十四届人大代表赴闽侯县、高新区、鼓楼区，开展“聚焦‘十五五’规划纲要编制 推动经济社会高质量发展”专题调研活动。市领导张定锋、陈忠霖陪同调研。"
  },

  {
    "url": "https://mp.weixin.qq.com/s/rWi_Uzr4_CIjUMm3JkXaig",
    "month": "2025年9月",
    "day": "12",
    "img": require("../assets/img/aboutUs/news/9-5.jpg"),
    "title": "中启联信亮相2025闽港人工智能创新技术合作专场活动",
    "content": "作为第二十五届中国国际投资贸易洽谈会的重要活动，本次专场以“‘香’约‘福’见 智能·智造·智慧”为主题，汇聚了闽港两地高校院所、AI企业专家及代表约150人，旨在汇聚科创力量，打造推动闽港科创互动的核心引擎。"
  },

  {
    "url": "https://mp.weixin.qq.com/s/uW2e3A9auQ2xF70WrM3dVQ",
    "month": "2025年9月",
    "day": "12",
    "img": require("../assets/img/aboutUs/news/9-4.jpg"),
    "title": "中启联信与果不其然达成并购协议 聚力赋能共推无障碍服务新发展",
    "content": "近日，中启联信科技集团（以下简称“中启联信”）与果不其然无障碍科技（苏州）有限公司（以下简称“果不其然”）正式达成并购合作协议。此次并购不仅是中启联信在人工智能与大数据技术深度融合战略中的关键一步，也标志着集团在无障碍科技与社会普惠服务领域实现系统性布局。"
  },

  {
    "url": "https://mp.weixin.qq.com/s/nh6S5Y2_atquZhiGT2rmVA",
    "month": "2025年9月",
    "day": "5",
    "img": require("../assets/img/aboutUs/news/9-3.png"),
    "title": "共观阅兵展国威 砥砺奋进新征程——中启联信组织员工观看阅兵直播",
    "content": "2025年9月3日上午，庆祝中华人民共和国成立76周年阅兵仪式在北京隆重举行。中启联信科技集团（以下简称“中启联信”）组织全体员工集中观看阅兵直播，共同庆祝这一盛大时刻，感受国家的强大与自豪。"
  },

  {
    "url": "https://mp.weixin.qq.com/s/j6la_hW0Wxn5Tp5TqjVhCQ",
    "month": "2025年9月",
    "day": "1",
    "img": require("../assets/img/aboutUs/news/9-2.jpg"),
    "title": "2025数博会丨中启联信受邀参加数据标注高端对话暨供需对接会",
    "content": "8月29日，2025中国国际大数据产业博览会“数据标注高端对话暨供需对接会”在贵阳国际生态会议中心成功举办。本次活动由国家数据局数字科技和基础设施建设司指导，贵州省大数据发展管理局主办，国家工业信息安全发展研究中心、国家发展和改革委员会培训中心（宣传中心）、中国电信集团有限公司、中国信息协会联合承办。中启联信科技集团（以下简称“中启联信”）作为数据标注领域的领先企业受邀参加此次活动。"
  },

  {
    "url": "https://mp.weixin.qq.com/s/UxKsvQr3YIYx9HesdK6bZg",
    "month": "2025年9月",
    "day": "1",
    "img": require("../assets/img/aboutUs/news/9-1.jpg"),
    "title": "响应国家“人工智能+”行动，中启联信以数智化服务赋能产业新发展",
    "content": "8月26日，国务院正式发布《关于深入实施“人工智能+”行动的意见》（以下简称“意见”），以科技、产业、消费、民生、治理、全球合作等领域为重点，深入实施“人工智能+”行动，推动人工智能与经济社会各行业各领域广泛深度融合。"
  },

  {
    "url": "https://mp.weixin.qq.com/s/FF5hENSYaSQTegWnC4s70Q",
    "month": "2025年8月",
    "day": "25",
    "img": require("../assets/img/aboutUs/news/news8-5.png"),
    "title": "省政协提案委与省发改委联合开展政协提案与“十五五”规划双向赋能专题调研",
    "content": "8月22日上午，省政协提案委联合省发改委，组织部分省政协委员、专家学者赴福州软件园，开展“人工智能产业发展”专题调研。省政协提案委主任胡忠昭，省政协提案副主任夏良玉，数字中国研究院（福建）院长宋志刚，省发改委党组成员、副主任王高辉等领导出席调研活动。"
  },
  
  {
    "url": "https://mp.weixin.qq.com/s/c5sVeujfrdmm3zosNJPKBg",
    "month": "2025年8月",
    "day": "18",
    "img": require("../assets/img/aboutUs/news/news8-4.png"),
    "title": "中启联信入选工信部“人工智能标准化技术委员会”成员单位",
    "content": "为推动人工智能高质量发展和高水平赋能新型工业化，2024年12月27日，工业和信息化部人工智能标准化技术委员会（以下简称“人工智能标委会”）在京正式成立，标志着我国人工智能行业标准化工作迈入新阶段。经严格评审，中启联信科技集团（以下简称“中启联信”）凭借深厚的技术积累与行业影响力，成功入选人工智能标委会成员单位。"
  },

  {
    "url": "https://mp.weixin.qq.com/s/BS4VvUSaCCHlNcdHoaBk6w",
    "month": "2025年8月",
    "day": "15",
    "img": require("../assets/img/aboutUs/news/news8-3.png"),
    "title": "【高质量完成“十四五”规划系列主题新闻发布会】 介绍“十四五”时期数字中国建设发展成就",
    "content": "2025年8月14日，国务院新闻办公室举行了第十一场“高质量完成‘十四五’规划”系列主题新闻发布会，介绍“十四五”时期数字中国建设发展成就。新闻发布会邀请到国家发展改革委党组成员、国家数据局局长刘烈宏先生，为大家介绍“十四五”时期数字中国建设发展成就，并回答大家关心的问题。出席新闻发布会的还有：国家数据局副局长沈竹林先生，副局长陈荣辉先生，副局长夏冰先生。"
  },

  {
    "url": "https://mp.weixin.qq.com/s/S-EYBHhrZfiHGMxQV_P9qg",
    "month": "2025年8月",
    "day": "2",
    "img": require("../assets/img/aboutUs/news/news8-2.png"),
    "title": "中启联信携最新成果亮相2025世界人工智能大会 共绘智能时代发展蓝图",
    "content": "2025世界人工智能大会暨人工智能全球治理高级别会议于7月26日至28日在上海举行。本届大会以“智能时代 同球共济”为主题，汇聚30多个国家和地区的顶尖专家、80余位中外院士领衔的1300余位嘉宾。盛会凝聚全球智慧，深入探讨人工智能技术前沿、产业趋势及治理路径，共同擘画人工智能发展的崭新未来。"
  },

  {
    "url": "https://mp.weixin.qq.com/s/GdVGRZogS2aFC_xBy04cHw",
    "month": "2025年7月",
    "day": "18",
    "img": require("../assets/img/aboutUs/news/item7-4.png"),
    "title": "中启联信成为北京市数标委工作组成员单位",
    "content": "近日，全球数字经济大会数据要素发展论坛在北京国家会议中心召开。会上，北京市数据标准化技术委员会（以下简称“北京市数标委”）举办工作组授牌仪式。中启联信科技集团成为北京市数据标准化技术委员会工作组成员单位。"
  },
  
  {
  "url": "https://mp.weixin.qq.com/s/k5SbWG7e_rXbh8qQtz6hqQ",
  "month": "2025年7月",
  "day": "8",
  "img": require("../assets/img/aboutUs/news/item7-3.png"),
  "title": "山东省人民政府驻上海办事处党委书记、主任张义英莅临中启联信调研指导",
  "content": "为深入贯彻落实山东省委、省政府关于人才强省与区域协调发展战略，进一步密切山东与福建人才产业的深度对接，6月28日至7月3日，山东省政府驻上海办事处党委书记、主任张义英带队赴福建开展人才产业考察交流活动。"
},
  {
  "url": "https://mp.weixin.qq.com/s/Y2nVDId746HXqBYn6ymTTQ",
  "month": "2025年7月",
  "day": "4",
  "img": require("../assets/img/aboutUs/news/item7-2.png"),
  "title": "福州职业技术学院与中启联信科技集团校外实训基地授牌暨双向聘任仪式圆满举行",
  "content": "7月4日，福州职业技术学院与中启联信科技集团（以下简称“中启联信”）举行校外实训基地授牌及校企导师聘任仪式。福州职业技术学院特殊教育学院院长沈丽娟、教授雷晓斌等校方代表，中启联信科技集团董事长辜俊杰及企业核心团队出席活动，标志着双方在产教融合与特殊教育数字化领域迈出实质性步伐。"
},
  {
  "url": "https://mp.weixin.qq.com/s/QVaJomFNyMq_9tjCOQ9ehg",
  "month": "2025年7月",
  "day": "2",
  "img": require("../assets/img/aboutUs/news/item7-1.jpg"),
  "title": "中启联信入选2025全球数字经济大会数据要素优秀产品、解决方案与案例",
  "content": "7月2日上午，2025全球数字经济大会在北京国家会议中心开幕。本届大会以“建设数字友好城市”为主题，吸引了全球50多个国家及重要国际组织的300余位国际嘉宾、上千名嘉宾参会。开幕式于上午9时正式开始。中央宣传部副部长，中央网信办主任、国家网信办主任庄荣文，新华社社长、党组书记傅华，国家发展改革委党组成员，国家数据局党组书记、局长刘烈宏等国家部委领导致辞。"
},

   {
  "url": "https://mp.weixin.qq.com/s/SL4XSsFhFGqO-_naKyFG4g",
  "month": "2025年6月",
  "day": "28",
  "img": require("../assets/img/aboutUs/news/item6-7.png"),
  "title": "赵龙在福州专题调研未来产业发展工作",
  "content": "6月25日，省长赵龙在福州专题调研未来产业发展工作。他强调，要深入学习贯彻习近平总书记在福建考察时的重要讲话精神，坚持因地制宜，强化前瞻布局，加快培育壮大战略性新兴产业和未来产业，推动科技创新和产业创新深度融合，大力发展新质生产力，建设体现福建特色现代化产业体系，为在中国式现代化建设中奋勇争先提供坚实支撑。省委副书记、福州市委书记郭宁宁参加。"
},
  {
  "url": "https://mp.weixin.qq.com/s/91UpSA6gwD-EdGqBvRjm6w",
  "month": "2025年6月",
  "day": "20",
  "img": require("../assets/img/aboutUs/news/item6-6.png"),
  "title": "中启联信入选福建省首批入库数据企业名单",
  "content": "6月18日，福建省数据管理局公布《福建省第一批数据企业名单》。经严格筛选与综合评定，中启联信科技集团凭借在数据技术领域的深度积累与创新实践，成功入选数据技术企业。这标志着公司在数据技术落地与场景化服务能力方面获得权威肯定，综合实力迈上新台阶。"
},
  {
  "url": "https://mp.weixin.qq.com/s/0wdcjvqFIp4LWAX8jG5Crg",
  "month": "2025年6月",
  "day": "20",
  "img": require("../assets/img/aboutUs/news/item6-5.jpg"),
  "title": "星链生态 智启苍穹 | 中启联信签约加入福建省卫星应用产业联盟",
  "content": "6月18日，以“星链生态 智启苍穹”为主题的福建省卫星应用产业生态大会在第二十三届中国·海峡创新项目成果交易会上隆重召开。本次大会由福建省数据管理局指导，福建省招标采购集团有限公司、福州大学、福建省大数据集团有限公司主办。大会汇聚政府领导、院士专家、企业代表及生态伙伴，共商卫星应用产业创新发展路径。现场同步开启线上直播，数万云端观众共同见证这一盛况。"
},
   {
  "url": "https://mp.weixin.qq.com/s/pLo8TUdWqQYHaIgDkAPB0g",
  "month": "2025年6月",
  "day": "19",
  "img": require("../assets/img/aboutUs/news/item6-4.jpg"),
  "title": "海创会今天开幕，硬核科技亮相福州馆！",
  "content": "今天（6月18日）以“科技创新赋能产业创新”为主题的第二十三届中国·海峡创新项目成果交易会在福州开幕今年的海创会福州馆有哪些亮点？一起去现场了解一下"
},
  {
  "url": "https://mp.weixin.qq.com/s/Tw_9Cnqv1jS8odXURKkEjw",
  "month": "2025年6月",
  "day": "12",
  "img": require("../assets/img/aboutUs/news/item6-3.png"),
  "title": "来自福州市鼓楼区人民政府的一封感谢信",
  "content": "近日，福州市鼓楼区政府向中启联信科技集团发来感谢信，对中启联信在第八届数字中国建设峰会中的积极参与和重要奉献给予充分肯定与衷心感谢。"
},
     {
  "url": "https://mp.weixin.qq.com/s/olbEDZYmbJhPFpeBaN8dig",
  "month": "2025年6月",
  "day": "09",
  "img": require("../assets/img/aboutUs/news/item6-2.png"),
  "title": "五凤论见 | 加“数”共创，构筑数据要素可信流通新范式",
  "content": "新形势、新机遇下如何打通数据从资源到资产再到资本的转化路径让数据充分流通，发挥更高价值围绕这一热点话题5月30日第130期“五凤论见”数据服务专场活动在福州软件园举办"
},
    {
  "url": "https://mp.weixin.qq.com/s/HfMfz4IRgNXXZ_RDJZhiHQ",
  "month": "2025年6月",
  "day": "09",
  "img": require("../assets/img/aboutUs/news/item6-1.png"),
  "title": "中启联信入选《2025中国AI技术应用产业全图谱》",
  "content": "近日，智合标准中心联合业界权威专家正式发布《2025中国AI技术应用产业全景图谱》及标杆案例。该项目旨在以全景视角厘清AI技术应用生态，通过专业化的产业分层体系与精细化的要素整合框架，全面呈现AI技术从基础研究到行业应用的完整生态链条，推动产业资源高效对接与协同创新。"
},
  {
  "url": "https://mp.weixin.qq.com/s/3Arapv0sBJP6nA93HIhjRA",
  "month": "2025年5月",
  "day": "26",
  "img": require("../assets/img/aboutUs/news/item5-1.jpg"),
  "title": "吉木萨尔县委网信办赴福建取经 助力网络舆情处置能力提质增效",
  "content": "为进一步提升网络舆情应对处置能力，推动网络综合治理水平迈上新台阶，5月21日—27日，吉木萨尔县委网信办在福建省举办“丝路同源·智惠厦吉”2025年吉木萨尔县网络安全与舆情高效处置专题培训班，来自吉木萨尔县各乡镇及部门的31名网信骨干参加培训。培训通过“理论授课+现场教学+经验交流”三位一体模式，提高了学员们负面舆情发现能力与处置方法。"
},
{
  "url": "https://mp.weixin.qq.com/s/SHdcOt06VLgYJ6Y9pC64VA",
  "month": "2025年5月",
  "day": "21",
  "img": require("../assets/img/aboutUs/news/item5-2.jpg"),
  "title": "有福之州 万商云集 | 中启联信在5·18海交会现场签约人工智能与大数据产业基地项目",
  "content": "5月18日，第二十七届海峡两岸经贸交易会（以下简称“海交会”）在福州海峡国际会展中心开幕。中启联信科技集团（以下简称“中启联信”）受邀参加了系列活动。"
},
{
  "url": "https://mp.weixin.qq.com/s/FziWfqfw4nqceuKboGu_mw",
  "month": "2025年5月",
  "day": "16",
  "img": require("../assets/img/aboutUs/news/item5-3.png"),
  "title": "【集团招聘】职等你来 共创未来！",
  "content": "在数字化浪潮汹涌澎湃的当下 数据已然成为驱动企业发展的核心动力 中启联信科技集团以 AI 技术为利刃 深度切割数据价值的无限可能 让数据资产在瞬息万变的市场环境中持续进化 正以卓越的专业能力与创新精神 引领数据资产迈向智能化增值新时代"
},
{
  "url": "https://mp.weixin.qq.com/s/951fe1FS8nddfF7rtRG6NA",
  "month": "2025年5月",
  "day": "13",
  "img": require("../assets/img/aboutUs/news/item5-4.jpg"),
  "title": "AI赋能 | 中启联信参加福建省第三十五次全国助残日活动",
  "content": "5月13日，福建省第三十五次全国助残日活动在福州举办，本次活动以“弘扬自强与助残精神 凝聚团结奋进力量”为主题，旨在进一步加快推进科技助残，助力残疾人事业在中国式现代化进程中实现全面高质量发展。福建省残联党组书记、理事长宿利南，省残联党组成员、副理事长赖勤学一行深入活动现场调研指导。中启联信科技集团（以下简称“中启联信”）作为科技助残企业代表，携自主研发的智能手语翻译系统参加活动。"
},
{
  "url": "https://mp.weixin.qq.com/s/_N7Y6-7QcofZWBzC6tDZ0Q",
  "month": "2025年5月",
  "day": "14",
  "img": require("../assets/img/aboutUs/news/item5-5.png"),
  "title": "中启联信参编的全国数标委《可信数据空间 技术架构》技术文件发布",
  "content": "4月30日上午，山西省政协副主席李正印、山西省委网信办副主任郭江坪、山西省数据局副局长王志刚等领导来到中启联信展位参观调研，深入调研企业在大数据、人工智能等领域的技术创新成果。"
},
{
  "url": "https://mp.weixin.qq.com/s/htX4mFHPgc-XSgj6pVX_OQ",
  "month": "2025年4月",
  "day": "30",
  "img": require("../assets/img/aboutUs/news/item4-1.jpg"),
  "title": "山西省政协副主席李正印一行在中启联信参观调研",
  "content": "4月30日上午，山西省政协副主席李正印、山西省委网信办副主任郭江坪、山西省数据局副局长王志刚等领导来到中启联信展位参观调研，深入调研企业在大数据、人工智能等领域的技术创新成果。"
},
{
  "url": "https://mp.weixin.qq.com/s/10EXgCQad8wzaD67MAuCpA",
  "month": "2025年4月",
  "day": "28",
  "img": require("../assets/img/aboutUs/news/item4-2.jpg"),
  "title": "中启联信参展第八届数字中国建设峰会，鼓楼区委书记黄建新莅临视察指导！",
  "content": "4月27日上午，福州市人大常委会副主任、鼓楼区委书记黄建新带队莅临“第八届数字中国建设峰会”冶山春秋园数字应用场景，现场指导工作。"
},
{
  "url": "https://mp.weixin.qq.com/s/q8nN9nJrEoFkJapu0U06zw",
  "month": "2025年4月",
  "day": "24",
  "img": require("../assets/img/aboutUs/news/item4-3.png"),
  "title": "走进福职院 | 以科技为桥梁 传递爱与温暖",
  "content": "为进一步促进听障人士就业、实现社会融入，促进听障人士实现自身价值，推动形成理解、关心、支持听障人士就业的良好社会环境。4月23日下午，中启联信科技集团（以下简称“中启联信）主动作为，深入校园精准对接岗位需求，与福州职业技术学院特殊教育学院开展交流合作。"
},
{
  "url": "https://mp.weixin.qq.com/s/qZAr76Giy6-Aj__8IOvUVg",
  "month": "2025年4月",
  "day": "21",
  "img": require("../assets/img/aboutUs/news/item4-4.png"),
  "title": "校企共建 AI高质量数据标注产教融合基地",
  "content": "目前AI与大数据产业正处于爆发期，据《2024年数字经济人才白皮书》显示，AI数据工程师岗位空缺率高达42%，企业普遍面临“技术迭代快、复合型人才稀缺”的困境。同时国家《职业教育改革实施方案》明确提出“推动校企深度合作，建设产教融合型实训基地”。"
},
{
  "url": "https://mp.weixin.qq.com/s/Fd-f94zmakp69Je9gPb3cQ",
  "month": "2025年4月",
  "day": "01",
  "img": require("../assets/img/aboutUs/news/item4-5.png"),
  "title": "喜讯简报 | 中启联信科技集团参与起草的《公共数据资源授权运营合规要求》团体标准正式发布",
  "content": "3月28日，由中国电子商会正式发布T/CECC 37—2025《公共数据资源授权运营合规要求》团体标准（以下简称“《标准》”）。这一标准明确公共数据授权运营的基本原则、运营流程与运营规范，为各相关主体提供了可供借鉴参考的具体合规手段与合规方法。"
},
{
  "url": "https://mp.weixin.qq.com/s/Xo6dWOSyhdvhscCOFGGsVA",
  "month": "2025年3月",
  "day": "26",
  "img": require("../assets/img/aboutUs/news/1.jpg"),
  "title": "福州软件园管委会黄瑞忠主任莅临中启联信科技集团参观调研",
  "content": "3月25 日，福州软件园管委会主任黄瑞忠一行莅临中启联信科技集团有限公司调研指导。中启联信科技集团董事长辜俊杰、技术总监杜江等陪同调研。"
},
{
  "url": "https://mp.weixin.qq.com/s/VEiF1oEuDeak9iI5jVhWrw",
  "month": "2025年3月",
  "day": "25",
  "img": require("../assets/img/aboutUs/news/2.jpg"),
  "title": "政企携手 共探AI未来 | 闽清县领导一行莅临中启联信考察交流",
  "content": "3月24日，闽清县工信（商务）局局长刘敏、大数据中心主任罗训丽、招商办副主任陈婷及陈杰等领导一行莅临中启联信科技集团参观指导。集团董事长辜俊杰、技术总监杜江、产品总监刘侃等热情接待，并围绕县级AI大数据应用场景的落地与创新展开深度交流。"
},
{
  "url": "https://mp.weixin.qq.com/s/dNVvcSDqvMhpIh5mxaCLHw",
  "month": "2025年3月",
  "day": "21",
  "img": require("../assets/img/aboutUs/news/3.jpg"),
  "title": "中启联信受邀参加“2025年数据标注产业供需对接会”",
  "content": "2025年3月18日-20日，数据标注基地先行先试现场会在四川省成都市召开。国家数据局党组书记、局长刘烈宏出席会议并讲话，四川省成都市人大常委会主任、党组书记张剡出席会议并致辞，国家数据局副局长夏冰主持会议。"
}
]

export default  newList;
